import { TotalLandDamageBase } from './base/total-land-damage-base';

export class TotalLandDamage extends TotalLandDamageBase { }